import React from 'react';
import '../components/styles/loader.css';
import { logo } from "../assets/svg/svg.js";

const Loader = (props) => {
  const baseClass = props.text ? "loader-container" : "loader-container-text";
  const modifierClass = props.isMain
    ? " main-loader-class"
    : props.normal
      ? " normal-loader-div"
      : "";

  return (
    <div
      className={`${baseClass}${modifierClass} ${props.text ? 'loader-my-div' : ''}`}
    >
      {logo.dmail_loader}
      {props.text && <p className="loaderText">{props.text}</p>}
    </div>
  );
};

export default Loader;
